import React from 'react';
import PropTypes from 'prop-types';

import WeddingEventCreateReviewStepUpdate from './WeddingEventCreateReviewStepUpdate';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const WEDDING_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL =
  'modal/WEDDING_EVENT_CREATE_REVIEW_STEP_UPDATE';

const propTypes = {
  actionProps: PropTypes.shape({
    step: PropTypes.shape({
      validate: PropTypes.func,
      component: PropTypes.node,
    }),
  }),
  onRequestClose: PropTypes.func,
};

const WeddingEventCreateReviewStepUpdateModal = ({
  actionProps: { step } = {},
  onRequestClose,
  ...props
}) => {
  if (!step?.component) {
    return null;
  }

  return (
    <WeddingEventCreateReviewStepUpdate
      step={step}
      onComplete={onRequestClose}
      {...props}
    />
  );
};

WeddingEventCreateReviewStepUpdateModal.propTypes = propTypes;

export default withModal(WeddingEventCreateReviewStepUpdateModal, {
  name: WEDDING_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL,
  size: 'md',
  type: 'full',
});
